import React from "react";
import skills from "../../data/skills";
import "./Skills.scss";

const Skills = ({ setCursorVariant }) => {
  const objectEnter = () => {
    setCursorVariant("text");
  };
  const objectLeave = () => {
    setCursorVariant("default");
  };
  return (
    <div
      className="skills-wrapper"
      data-scroll-section
      onMouseEnter={objectEnter}
      onMouseLeave={objectLeave}
    >
      <div
        className="skills-title"
        data-scroll
        data-scroll-direction="horizontal"
        data-scroll-static
      >
        development skills
      </div>
      <div className="skills-set1">
        {skills.slice(0, 7).map((item, index) => (
          <div
            key={index}
            className="each-skill"
            data-scroll
            data-scroll-direction="horizontal"
            data-scroll-speed="8"
          >
            <div
              className="skills-image"
              key={item.name}
              style={{ backgroundImage: `url(${item.src})` }}
            ></div>
            <p className="skill-name">{item.name}</p>
          </div>
        ))}
      </div>
      <div className="skills-set2">
        {skills.slice(7, 14).map((item, index) => (
          <div
            key={index}
            className="each-skill"
            data-scroll
            data-scroll-direction="horizontal"
            data-scroll-speed="7"
          >
            <svg
              className="skills-image"
              key={item.name}
              style={{ backgroundImage: `url(${item.src})` }}
            ></svg>
            <p className="skill-name">{item.name}</p>
          </div>
        ))}
      </div>
      <div className="skills-set3">
        {skills.slice(14, 22).map((item, index) => (
          <div
            key={index}
            className="each-skill"
            data-scroll
            data-scroll-direction="horizontal"
            data-scroll-speed="6"
          >
            <div
              className="skills-image"
              key={item.name}
              style={{ backgroundImage: `url(${item.src})` }}
            ></div>
            <p className="skill-name">{item.name}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Skills;
